import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, of, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';


@Injectable({ providedIn: 'root' })
export class NsideIdentityService {

  private apiToken: string | null = null;
  private tokenExpiry: number = 0;

  constructor(private http: HttpClient) {}

  // Ask Identity Gateway to verify cookie
  getUser() {
    return this.http
      .post<any>(`${environment.identityUrl}/verify-session`, {}, {
        withCredentials: true
      })
      .pipe(
        map(res => res.claims),
        catchError(() => of(null))
      );
  }

  isAuthenticated() {
    return this.getUser().pipe(
      map(user => !!user)
    );
  }

  // Get API token from identity-v2 (exchanges session cookie for Bearer JWT)
  fetchApiToken(): Observable<string | null> {
    return this.http
      .post<any>(`${environment.identityUrl}/api/get-api-token`, {}, {
        withCredentials: true
      })
      .pipe(
        map(res => {
          if (res.success && res.api_token) {
            this.apiToken = res.api_token;
            // Set expiry with 60s buffer before actual expiry
            this.tokenExpiry = Date.now() + ((res.expires_in - 60) * 1000);
            return this.apiToken;
          }
          return null;
        }),
        catchError(() => of(null))
      );
  }

  getToken(): string | null {
    if (this.apiToken && Date.now() < this.tokenExpiry) {
      return this.apiToken;
    }
    return null;
  }

  isTokenValid(): boolean {
    return !!this.getToken();
  }

  clearToken() {
    this.apiToken = null;
    this.tokenExpiry = 0;
  }

  logout() {
    this.clearToken();
    window.location.href = `${environment.identityUrl}/logout`;
  }
}
